<template>
	<label
		class="form-element"
		:class="labelClassObject"
	>
		<div class="form-element__field">
			<slot />
		</div>
		<div class="form-element__message">
			{{ message }}
		</div>
	</label>
</template>

<script>
export default {
	props: {
		id: { type: String, default: '' },
		label: { type: String, default: '' },
		classList: { type: Object, default: () => ({}) },
		message: { type: String, default: '' },
		describe: { type: String, default: '' },
		required: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		valid: { type: Boolean, default: false },
		error: { type: Boolean, default: false },
	},

	computed: {
		labelClassObject() {
			let classList = {
				'valid': this.valid ,
				'form-element--error': this.error,
				'form-element__required': this.required,
				'readonly': this.readonly,
				'disabled': this.disabled
			};

			if (this.classList) {
				classList = {
					...classList,
					...this.classList,
				};
			}

			return classList;

		}
	},
};
</script>
